export const translation = {
  zenit: {
    en: {
      siteTitle: "Bet on sports with cashback",
      rulesBtnText: "Rules",
      titleLine1: "Get",
      titleLine2: "cashback",
      titleLine3: 'on ice hockey',
      titleLine4: 'up to 670$',
      btnGet: "Join",
      conditionSpan1: "Register",
      conditionSpan1Extra: "",
      conditionSpan1Part2: "or log in",
      conditionText1: "",
      conditionSpan2: "Place",
      conditionText2Extra: "",
      conditionText2: "bets",
      specialCondition: "For all sports",
      conditionExtra3: "Get",
      conditionSpan3: "cashback",
      conditionText3: "every day",
      bkString: "Bookmaker Zenit",
      rightString: "All rights reserved",
      footnoteText: '*more details in the Promotion rules',
      supportText: "Support center:",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: "Terms and conditions of the Promotion",
      paragraph1: '1. The Promotion is available from its launch moment until 19.01.2022. Information about the Promotion launch will be posted on the Bookmaker website Zenit (zenitbet.com).',
      paragraph2: '2. The dates of the Promotion are determined by Bookmaker Zenit and may be changed at any time for any reason and without additional notification.',
      paragraph3: '3. To take part in the Promotion, you must sign in or register at zenitbet.com during the Promotion dates and press "Join".',
      paragraph4: '4. Cashback is credited in the form of a free bet.',
      paragraph5: '5. Terms of receiving a free bet:',
      paragraph6: '6. Bonuses shall not be credited if the following has occurred:',
      paragraph7: `7. Bookmaker Zenit reserves the right to cancel the free bet accrual, suspend a participant from taking part in any of the Bookmaker's Promotions and declare any of their activities invalid if Bookmaker Zenit reasonably suspects that they have knowingly fulfilled the Promotion requirements in bad faith, abused the Promotion, falsified information or taken advantage of any falsified information required to participate in the Promotion, including but not limited to the following:`,
      paragraph8: `8. If Bookmaker Zenit discovers that any of the Promotion Terms and conditions have been violated, the Bookmaker is entitled to cancel the Participant's right to receive free bets, annul any winnings from the free bets and block the Participant's account.`,
      paragraph9: '9. Conditions for using the free bet:',
      paragraph10: '10. If you win, only the net profit is paid out, i.e. the free bet amount is subtracted out of your winnings. The free bet can only be used once.',
      paragraph11: '11. Terms and conditions of the Promotion can be changed at any time without providing a reason or additional notifications.',
      paragraph12: '12. By using the free bet option, you fully agree to these Terms and conditions.',
      tableLeftTopText:'Number of bonuses per day',
      tableCenterTopText:'Free bet amount (in currencies)',
      tableCurrencyRUB:'RUB',
      tableCurrencyUSD:'USD',
      tableCurrencyEUR:'EUR',
      tableCurrencyIRR:'IRR',
      tableCurrencyBRL:'BRL',
      tableCurrencyUAH:'UAH',
      tableCurrencyKZT:'KZT',
      tableCurrencyPRB:'PRB',
      tableCurrencyTMT:'TMT',
      tableCurrencyMDL:'MDL',
      noFreebetText: 'free bet shall not be credited',
      subParagraph51: `5.1. The Promotion includes any sport events bets from the Sports and Live sections, which take place during the Promotion period, except for U18 tournaments, non-sports, statistical and outright bets.`,
      subParagraph52: '5.2. For each bet specified in Clause 5.1, you shall be credited bonuses daily according to the following:',
      subInnerParagraph521: '5.2.1. Winning bet: profit (equivalent in RUB)*1%.',
      subInnerParagraph522: '5.2.2. Losing bet: bet amount (equivalent in RUB)*5%.',
      subParagraph53: '5.3. For received bonuses, you shall be credited a free bet daily. The free bet amount shall vary based on the number of bonuses you have received:',
      subParagraph54: '5.4. Free bet shall not be credited if the number of bonuses accumulated per day is less than 100.',
      subParagraph55: '5.5. Free bets are credited daily from 12 a.m. to 3 a.m. (UTC+03:00).',
      subParagraph61: '6.1. The bet was placed on U18 tournaments, non-sports, statistics or outright.',
      subParagraph62: '6.2. The bet has been placed using a free bet.',
      subParagraph63: '6.3. The bet has already been counted under a different promotion of the bookmaker.',
      subParagraph64: '6.4. The bet has been sold by the participant, given the sale of bets is stipulated by the Bet acceptance rules.',
      subParagraph91: '9.1. The free bet can be used after being checked for compliance with the requirements specified in Clause 5 of these Terms and conditions within 7 days.',
      subParagraph92: '9.2. You can only use the free bet in its entirety to place a bet.',
      subParagraphLetter71: 'a) the participant has been found to have performed actions that caused or may have caused adverse effects of any kind and extent for Bookmaker Zenit, other participants and/or third parties;',
      subParagraphLetter72: 'b) the Participant has been found to have provided incorrect information;',
      subParagraphLetter73: 'c) the Participant has violated the Terms and conditions of the Promotion;',
      subParagraphLetter74: 'd) the Participant has violated the gambling rules and/or any other rules in effect;',
      subParagraphLetter75: `e) the Participant's account has been blocked.`,
    },
    ru: {
      siteTitle: "Заряжай на спорт с кешбэком",
      rulesBtnText: "Правила",
      titleLine1: "",
      titleLine2: "Кешбэк",
      titleLine3: "за ставки",
      titleLine4: "на хоккей",
      titleLine5: "до 50 000 ₽",
      btnGet: "Участвовать",
      conditionSpan1: "Регистрируйся",
      conditionSpan1Extra: "или",
      conditionText1: "авторизуйся на сайте",
      conditionSpan2: `Делай
      `,
      conditionText2: `ставки`,
      specialCondition: "Всё",
      conditionSpan3: "Лови",
      conditionText3: `свой кешбэк
        каждый день`,
      bkString: "Букмекерская контора Зенит",
      rightString: "Все права защищены",
      footnoteText: '*подробнее в правилах Акции',
      supportText: "Служба поддержки:",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: "Правила участия в Акции",
      paragraph1: '1. Акция действительна с момента запуска и по 19.01.2022 г. Информация о запуске Акции будет размещена на сайте БК «Зенит» (zenitbet.com).',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК «Зенит» и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции зарегистрироваться или авторизоваться на сайте zenitbet.com, а также обязательно подтвердить свое участие в Акции нажатием на кнопку «Участвовать».',
      paragraph4: '4. Кешбэк начисляется в виде фрибета.',
      paragraph5: '5. Условия начисления фрибета (бесплатной ставки):',
      paragraph6: '6. Бонусы не начисляются в следующих случаях:',
      paragraph7: '7. БК «Зенит» вправе отказать участнику Акции в начислении бесплатной ставки (фрибета), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «Зенит» возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими, искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:',
      paragraph8: '8. В случае обнаружения любого из нарушений правил Акции БК «Зенит» вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок, и заблокировать аккаунт участника Акции.',
      paragraph9: '9. Условия использования фрибетов:',
      paragraph10: '10. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph11: '11. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph12: '12. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText:'Количество бонусов за день',
      tableCenterTopText:'Сумма бесплатной ставки (фрибет) в валюте',
      tableCurrencyRUB:'RUB',
      tableCurrencyUSD:'USD',
      tableCurrencyEUR:'EUR',
      tableCurrencyIRR:'IRR',
      tableCurrencyBRL:'BRL',
      tableCurrencyUAH:'UAH',
      tableCurrencyKZT:'KZT',
      tableCurrencyPRB:'PRB',
      tableCurrencyTMT:'TMT',
      tableCurrencyMDL:'MDL',
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph51: '5.1. В Акции участвуют ставки на любые спортивные события из разделов Линия и Live, которые проходят в период проведения Акции, кроме статистических и долгосрочных ставок, а также любых событий из молодежных лиг (возрастная группа до 18 лет).',
      subParagraph52: '5.2. За все ставки из п.5.1. Участнику Акции ежедневно начисляются бонусы в количестве:',
      subInnerParagraph521: '5.2.1. Выигрышная ставка: сумма выигрыша (эквивалент в руб)*1%.',
      subInnerParagraph522: '5.2.2. Проигрышная ставка: сумма ставки (эквивалент в руб)*5%.',
      subParagraph53: '5.3. За полученные бонусы Участнику Акции ежедневно будет начисляться фрибет. Сумма фрибета зависит от количества накопленных за день бонусов:',
      subParagraph54: '5.4. Если количество бонусов, накопленных за день, меньше 100, бесплатная ставка не выдается.',
      subParagraph55: '5.5. Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3.',
      subParagraph61: '6.1. Ставка сделана на статистику, неспортивное или долгосрочное событие, а также матчи молодежных лиг (возрастная группа до 18 лет).',
      subParagraph62: '6.2. Ставка сделана с использованием бесплатной ставки.',
      subParagraph63: '6.3. Ставка уже была учтена в других акциях компании.',
      subParagraph64: '6.4. Ставка была продана участником Акции.',
      subParagraph91: '9.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 5 настоящих Правил, в течение 7 дней.',
      subParagraph92: '9.2. Совершить бесплатную ставку можно только на всю сумму фрибета.',
      subParagraphLetter71: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «Зенит», так и для иных участников и для третьих лиц;',
      subParagraphLetter72: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraphLetter73: 'в) участник нарушает Правила Акции;',
      subParagraphLetter74: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraphLetter75: 'д) аккаунт участника Акции заблокирован.',
    },
  },
  zenbet: {
    en: {
      siteTitle: "Bet on sports with cashback",
      rulesBtnText: "Rules",
      titleLine1: "Get",
      titleLine2: "cashback",
      titleLine3: 'on ice hockey',
      titleLine4: 'up to 670$',
      btnGet: "Join",
      conditionSpan1: "Register",
      conditionSpan1Extra: "",
      conditionSpan1Part2: "or log in",
      conditionText1: "",
      conditionSpan2: "Place",
      conditionText2Extra: "",
      conditionText2: "bets",
      specialCondition: "For all sports",
      conditionExtra3: "Get",
      conditionSpan3: "cashback",
      conditionText3: "every day",
      bkString: "Bookmaker ZENBET",
      rightString: "All rights reserved",
      footnoteText: '*more details in the Promotion rules',
      supportText: "Email: support@zen.bet",
      rulesHeaderText: "Terms and conditions of the Promotion",
      paragraph1: '1. The Promotion is available from its launch moment until 19.01.2022. Information about the Promotion launch will be posted on the Bookmaker website ZENBET (zen.bet).',
      paragraph2: '2. The dates of the Promotion are determined by Bookmaker ZENBET and may be changed at any time for any reason and without additional notification.',
      paragraph3: '3. To take part in the Promotion, you must sign in or register at zen.bet during the Promotion dates and press "Join".',
      paragraph4: '4. Cashback is credited in the form of a free bet.',
      paragraph5: '5. Terms of receiving a free bet:',
      paragraph6: '6. Bonuses shall not be credited if the following has occurred:',
      paragraph7: `7. Bookmaker ZENBET reserves the right to cancel the free bet accrual, suspend a participant from taking part in any of the Bookmaker's Promotions and declare any of their activities invalid if Bookmaker ZENBET reasonably suspects that they have knowingly fulfilled the Promotion requirements in bad faith, abused the Promotion, falsified information or taken advantage of any falsified information required to participate in the Promotion, including but not limited to the following:`,
      paragraph8: `8. If Bookmaker ZENBET discovers that any of the Promotion Terms and conditions have been violated, the Bookmaker is entitled to cancel the Participant's right to receive free bets, annul any winnings from the free bets and block the Participant's account.`,
      paragraph9: '9. Conditions for using the free bet:',
      paragraph10: '10. If you win, only the net profit is paid out, i.e. the free bet amount is subtracted out of your winnings. The free bet can only be used once.',
      paragraph11: '11. Terms and conditions of the Promotion can be changed at any time without providing a reason or additional notifications.',
      paragraph12: '12. By using the free bet option, you fully agree to these Terms and conditions.',
      tableLeftTopText:'Number of bonuses per day',
      tableCenterTopText:'Free bet amount (in currencies)',
      tableCurrencyRUB:'RUB',
      tableCurrencyUSD:'USD',
      tableCurrencyEUR:'EUR',
      tableCurrencyIRR:'IRR',
      tableCurrencyBRL:'BRL',
      tableCurrencyUAH:'UAH',
      tableCurrencyKZT:'KZT',
      tableCurrencyPRB:'PRB',
      tableCurrencyTMT:'TMT',
      tableCurrencyMDL:'MDL',
      noFreebetText: 'free bet shall not be credited',
      subParagraph51: `5.1. The Promotion includes any sport events bets from the Sports and Live sections, which take place during the Promotion period, except for U18 tournaments, non-sports, statistical and outright bets.`,
      subParagraph52: '5.2. For each bet specified in Clause 5.1, you shall be credited bonuses daily according to the following:',
      subInnerParagraph521: '5.2.1. Winning bet: profit (equivalent in USD)*1%.',
      subInnerParagraph522: '5.2.2. Losing bet: bet amount (equivalent in USD)*5%.',
      subParagraph53: '5.3. For received bonuses, you shall be credited a free bet daily. The free bet amount shall vary based on the number of bonuses you have received:',
      subParagraph54: '5.4. Free bet shall not be credited if the number of bonuses accumulated per day is less than 2.',
      subParagraph55: '5.5. Free bets are credited daily from 12 a.m. to 3 a.m. (UTC+03:00).',
      subParagraph61: '6.1. The bet was placed on U18 tournaments, non-sports, statistics or outright.',
      subParagraph62: '6.2. The bet has been placed using a free bet.',
      subParagraph63: '6.3. The bet has already been counted under a different promotion of the bookmaker.',
      subParagraph64: '6.4. The bet has been sold by the participant, given the sale of bets is stipulated by the Bet acceptance rules.',
      subParagraph91: '9.1. The free bet can be used after being checked for compliance with the requirements specified in Clause 5 of these Terms and conditions within 7 days.',
      subParagraph92: '9.2. You can only use the free bet in its entirety to place a bet.',
      subParagraphLetter71: 'a) the participant has been found to have performed actions that caused or may have caused adverse effects of any kind and extent for Bookmaker ZENBET, other participants and/or third parties;',
      subParagraphLetter72: 'b) the Participant has been found to have provided incorrect information;',
      subParagraphLetter73: 'c) the Participant has violated the Terms and conditions of the Promotion;',
      subParagraphLetter74: 'd) the Participant has violated the gambling rules and/or any other rules in effect;',
      subParagraphLetter75: `e) the Participant's account has been blocked.`,
    },
    ru: {
      siteTitle: "Заряжай на спорт с кешбэком",
      rulesBtnText: "Правила",
      titleLine1: "",
      titleLine2: "Получай",
      titleLine3: "кешбэк",
      titleLine4: "на хоккей",
      titleLine5: "до 670 $",
      btnGet: "Участвовать",
      conditionSpan1: "Регистрируйся",
      conditionSpan1Extra: "или",
      conditionText1: "авторизуйся на сайте",
      conditionSpan2: `Делай
      `,
      conditionText2: `ставки`,
      specialCondition: "Всё",
      conditionSpan3: "Лови",
      conditionText3: `свой кешбэк
        каждый день`,
      bkString: "Букмекерская контора ZENBET",
      rightString: "Все права защищены",
      footnoteText: '*подробнее в правилах Акции',
      supportText: "Email: support@zen.bet",
      rulesHeaderText: "Правила участия в Акции",
      paragraph1: '1. Акция действительна с момента запуска и по 19.01.2022 г. Информация о запуске Акции будет размещена на сайте БК ZENBET (zen.bet).',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК ZENBET и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции зарегистрироваться или авторизоваться на сайте zen.bet, а также обязательно подтвердить свое участие в Акции нажатием на кнопку «Участвовать».',
      paragraph4: '4. Кешбэк начисляется в виде фрибета.',
      paragraph5: '5. Условия начисления фрибета (бесплатной ставки):',
      paragraph6: '6. Бонусы не начисляются в следующих случаях:',
      paragraph7: '7. БК ZENBET вправе отказать участнику Акции в начислении бесплатной ставки (фрибета), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК ZENBET возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими, искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:',
      paragraph8: '8. В случае обнаружения любого из нарушений правил Акции БК ZENBET вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок, и заблокировать аккаунт участника Акции.',
      paragraph9: '9. Условия использования фрибетов:',
      paragraph10: '10. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph11: '11. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph12: '12. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText:'Количество бонусов за день',
      tableCenterTopText:'Сумма бесплатной ставки (фрибет) в валюте',
      tableCurrencyRUB:'RUB',
      tableCurrencyUSD:'USD',
      tableCurrencyEUR:'EUR',
      tableCurrencyIRR:'IRR',
      tableCurrencyBRL:'BRL',
      tableCurrencyUAH:'UAH',
      tableCurrencyKZT:'KZT',
      tableCurrencyPRB:'PRB',
      tableCurrencyTMT:'TMT',
      tableCurrencyMDL:'MDL',
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph51: '5.1. В Акции участвуют ставки на любые спортивные события из разделов Линия и Live, которые проходят в период проведения Акции, кроме статистических и долгосрочных ставок, а также любых событий из молодежных лиг (возрастная группа до 18 лет).',
      subParagraph52: '5.2. За все ставки из п.5.1. Участнику Акции ежедневно начисляются бонусы в количестве:',
      subInnerParagraph521: '5.2.1. Выигрышная ставка: сумма выигрыша (эквивалент в USD)*1%.',
      subInnerParagraph522: '5.2.2. Проигрышная ставка: сумма ставки (эквивалент в USD)*5%.',
      subParagraph53: '5.3. За полученные бонусы Участнику Акции ежедневно будет начисляться фрибет. Сумма фрибета зависит от количества накопленных за день бонусов:',
      subParagraph54: '5.4. Если количество бонусов, накопленных за день, меньше 2, бесплатная ставка не выдается.',
      subParagraph55: '5.5. Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3.',
      subParagraph61: '6.1. Ставка сделана на статистику, неспортивное или долгосрочное событие, а также матчи молодежных лиг (возрастная группа до 18 лет).',
      subParagraph62: '6.2. Ставка сделана с использованием бесплатной ставки.',
      subParagraph63: '6.3. Ставка уже была учтена в других акциях компании.',
      subParagraph64: '6.4. Ставка была продана участником Акции.',
      subParagraph91: '9.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 5 настоящих Правил, в течение 7 дней.',
      subParagraph92: '9.2. Совершить бесплатную ставку можно только на всю сумму фрибета.',
      subParagraphLetter71: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК ZENBET, так и для иных участников и для третьих лиц;',
      subParagraphLetter72: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraphLetter73: 'в) участник нарушает Правила Акции;',
      subParagraphLetter74: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraphLetter75: 'д) аккаунт участника Акции заблокирован.',
    },
  },
  cupis: {
    ru: {
      siteTitle: "Заряжай на спорт с кешбэком",
      rulesBtnText: "Правила",
      titleLine1: "",
      titleLine2: "Кешбэк",
      titleLine3: "за ставки",
      titleLine4: "на хоккей",
      titleLine5: "до 50 000 ₽",
      btnGet: "Участвовать",
      conditionSpan1: "Регистрируйся",
      conditionSpan1Extra: "или",
      conditionText1: "авторизуйся на сайте",
      conditionSpan2: `Делай
      `,
      conditionText2: `ставки`,
      specialCondition: "Всё",
      conditionSpan3: "Лови",
      conditionText3: `свой кешбэк
        каждый день`,
      bkString: "Букмекерская контора «Зенит»",
      rightString: "Все права защищены",
      footnoteText: '*подробнее в правилах Акции',
      supportText: "Служба поддержки:",
      supportSpan: "8 (800) 222-55-50",
      rulesHeaderText: "Правила участия в Акции",
      paragraph1: '1. Акция действительна с момента запуска и по 19.01.2022 г. Информация о запуске Акции будет размещена на сайте БК «Зенит» (zenit.win).',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК «Зенит» и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции зарегистрироваться или авторизоваться на сайте zenit.win.',
      paragraph4: '4. Кешбэк начисляется в виде фрибета.',
      paragraph5: '5. Условия начисления фрибета (бесплатной ставки):',
      paragraph6: '6. Бонусы не начисляются в следующих случаях:',
      paragraph7: '7. БК «Зенит» вправе отказать участнику Акции в начислении бесплатной ставки (фрибета), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «Зенит» возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими,  искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:',
      paragraph8: '8. В случае обнаружения любого из нарушений правил Акции БК «Зенит» вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок, и заблокировать аккаунт участника Акции.',
      paragraph9: '9. Условия использования фрибетов:',
      paragraph10: '10. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph11: '11. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph12: '12. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText:'Количество бонусов за день',
      tableCenterTopText:'Сумма бесплатной ставки (фрибет) в рублях',
      tableCurrencyRUB:'RUB',
      tableCurrencyUSD:'USD',
      tableCurrencyEUR:'EUR',
      tableCurrencyIRR:'IRR',
      tableCurrencyBRL:'BRL',
      tableCurrencyUAH:'UAH',
      tableCurrencyKZT:'KZT',
      tableCurrencyPRB:'PRB',
      tableCurrencyTMT:'TMT',
      tableCurrencyMDL:'MDL',
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph51: '5.1. В Акции участвуют ставки на любые спортивные события из разделов Линия и Live, которые проходят в период проведения Акции, кроме статистических и долгосрочных ставок.',
      subParagraph52: '5.2. За все ставки из п.5.1. Участнику Акции ежедневно начисляются бонусы в количестве:',
      subInnerParagraph521: '5.2.1. Выигрышная ставка: сумма выигрыша*1%.',
      subInnerParagraph522: '5.2.2. Проигрышная ставка: сумма ставки*5%.',
      subParagraph53: '5.3. За полученные бонусы Участнику Акции ежедневно будет начисляться фрибет. Сумма фрибета зависит от количества накопленных за день бонусов:',
      subParagraph54: '5.4. Если количество бонусов, накопленных за день, меньше 100, бесплатная ставка не выдается.',
      subParagraph55: '5.5. Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3.',
      subParagraph61: '6.1. Ставка сделана на статистику, неспортивное или долгосрочное событие.',
      subParagraph62: '6.2. Ставка сделана с использованием бесплатной ставки.',
      subParagraph63: '6.3. Ставка уже была учтена в других акциях компании.',
      subParagraph64: '6.4. Ставка была продана участником Акции.',
      subParagraph91: '9.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 5 настоящих Правил, в течение 7 дней.',
      subParagraph92: '9.2. Совершить бесплатную ставку можно только на всю сумму фрибета.',
      subParagraphLetter71: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «Зенит», так и для иных участников и для третьих лиц;',
      subParagraphLetter72: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraphLetter73: 'в) участник нарушает Правила Акции;',
      subParagraphLetter74: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraphLetter75: 'д) аккаунт участника Акции заблокирован.'
    }
  }
}
